import { Box } from '@chakra-ui/react';

export default function Badge({
  content,
  children,
}: React.PropsWithChildren<{ content?: string | number }>) {
  return (
    <Box position={'relative'}>
      {!!content && (
        <Box
          position={'absolute'}
          top={0}
          right={0}
          transform={'translate(30%, -30%)'}
          background={'black'}
          color={'white'}
          minW="20px"
          h="20px"
          p={'2px 4px'}
          boxSizing="content-box"
          borderRadius={'full'}
          fontSize={'12px'}
          fontWeight={'bold'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          zIndex={1}
        >
          {content}
        </Box>
      )}
      {children}
    </Box>
  );
}
